export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "/api/v1",
  platformName: import.meta.env.VITE_PLATFORM_NAME || "Chawowa",
};
